import { memo } from 'react';
import { GoCheckCircleFill } from 'react-icons/go';
import { HiLockClosed } from 'react-icons/hi';
import { FaCalendar } from 'react-icons/fa6';

function DayCard({
  dateKey,
  dayNumber,
  entry,
  property,
  room,
  isPast,
  isMobile,
  inRange,
  isStart,
  isEnd,
  excluded,
  preview,
  onMouseDown,
  onMouseEnter
}) {
  const isHotel = property?.propertyType === 'hotel';
  const isBooked = !!entry?.bookingId;

  let statusClass = '';
  let statusText = 'Available';
  if (isHotel && room) {
    const blockedCount = entry?.roomCount || 0;
    const blocked =
      !!entry?.isBlocked || (!!entry && room.count && blockedCount >= room.count);
    if (blocked) {
      statusClass = 'blocked';
      statusText = 'Blocked';
    } else {
      statusText = `${Math.max(room.count - blockedCount, 0)} left to sell`;
      if (isBooked) statusClass = 'booked';
    }
  } else if (entry?.isBlocked) {
    statusClass = 'blocked';
    statusText = 'Blocked';
  } else if (isBooked) {
    statusClass = 'booked';
    statusText = 'Booked';
  }

  const price =
    entry?.price ||
    room?.price ||
    property?.apartment?.prices?.find(i => Number(i?.occupancy) === 1)?.price ||
    0;
  const currency =
    room?.currency?.currencyId ||
    property?.apartment?.prices?.[0]?.currency?.currencyId ||
    'MAD';

  const className = [
    '__calender_day',
    statusClass && `--${statusClass}`,
    isPast && '--past',
    inRange && '--in-range',
    inRange && excluded && '--excluded',
    isStart && '--range-start',
    isEnd && '--range-end',
    preview && '--preview'
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      data-date={dateKey}
      className={className}
      style={{
        height: isMobile ? '100px' : '140px',
        padding: isMobile ? '5px' : '8px',
        userSelect: 'none',
        cursor: isPast ? 'not-allowed' : 'pointer'
      }}
      onMouseDown={e => {
        e.preventDefault();
        onMouseDown(dateKey);
      }}
      onMouseEnter={() => onMouseEnter(dateKey)}
    >
      {isStart && <span className="__range-handle --left" />}
      {isEnd && <span className="__range-handle --right" />}
      <p
        style={{
          fontWeight: 600,
          color: 'black',
          fontSize: isMobile ? '12px' : '14px',
          margin: 0
        }}
      >
        {dayNumber}
      </p>
      <p style={{ textAlign: 'center', margin: 0 }}>
        {statusClass === 'blocked' ? (
          <HiLockClosed size={isMobile ? 18 : 24} color="#e74c3c" />
        ) : statusClass === 'booked' ? (
          <GoCheckCircleFill size={isMobile ? 18 : 24} color="#27ae60" />
        ) : (
          <FaCalendar color="#c3c3c3" size={isMobile ? 18 : 24} />
        )}
      </p>
      {!isPast && (
        <>
          <p
            style={{
              textAlign: 'center',
              alignSelf: 'center',
              fontWeight: 500,
              fontSize: isMobile ? '10px' : '12px',
              margin: isMobile ? '2px 0' : '5px 0',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              width: '100%'
            }}
          >
            {statusText}
          </p>
          <p
            style={{
              textAlign: 'center',
              alignSelf: 'center',
              fontWeight: 500,
              color: 'green',
              fontSize: isMobile ? '10px' : '12px',
              margin: 0
            }}
          >
            {`${price} ${currency}`}
          </p>
        </>
      )}
    </div>
  );
}

export default memo(DayCard);
